<script>
  import Modal from "@components/shared/modal.svelte";
  import { get } from "@lib/requests";

  let { date = $bindable(null), clinic, onUpdate } = $props();

  let selectedId = $state("");
  let notes = $state("");
  let available = $state([]);

  let title = $derived(date ? `Ouverture du ${date.toLocaleDateString()}` : "Ouverture");

  $effect(() => {
    if (!selectedId) notes = "";
  });

  async function fetchData() {
    if (!date) return;

    try {
      const dateString = date.toISOString().split("T")[0];
      const response = await get(`/api/v1/clinic_openings/date?clinic=${clinic.id}&date=${dateString}`, { responseKind: "json" });
      const data = await response.json;

      available = data.available;
      selectedId = data.opening?.user?.id?.toString() || "";
      notes = data.opening?.notes || "";
    } catch (error) {
      console.error(error);
    }
  }

  function handleSubmit(e) {
    e.preventDefault();
    onUpdate?.(selectedId, notes);
  }
</script>

<Modal bind:open={date} title={title} onClose={() => date = null}>
  {#await fetchData()}
    <p>Chargement...</p>
  {:then}

    <form id="clinic-opening-form" onsubmit={handleSubmit}>
      <div class="form-items">
        <div class="form-item col-span-12">
          <label for="clinic-opening-opener">Responsable</label>

          <div id="clinic-opening-opener" class="grid grid-cols-2 gap-2">
            <label class="flex items-center justify-between gap-2 rounded-sm border border-gray-200 bg-white px-3 py-2 text-smaller text-gray-600 cursor-pointer transition has-[:checked]:border-teal-400 has-[:checked]:bg-teal-50/80 has-[:checked]:text-teal-700">
              <input type="radio" class="sr-only peer" name="opener" value="" bind:group={selectedId} />
              <span>Aucune ouverture</span>
              <span class="hidden text-teal-500 peer-checked:inline-block">✓</span>
            </label>

            {#each available as user (user.id)}
              <label class="flex items-center justify-between gap-2 rounded-sm border border-gray-200 bg-white px-3 py-2 text-smaller text-gray-600 cursor-pointer transition has-[:checked]:border-teal-400 has-[:checked]:bg-teal-50/80 has-[:checked]:text-teal-700">
                <input type="radio" class="sr-only peer" name="opener" value={user.id.toString()} bind:group={selectedId} />
                <span>{user.name}</span>
                <span class="hidden text-teal-500 peer-checked:inline-block">✓</span>
              </label>
            {/each}
          </div>
        </div>

        {#if selectedId}
          <div class="form-item col-span-12">
            <label for="clinic-opening-notes">Notes</label>
            <textarea name="notes" id="clinic-opening-notes" bind:value={notes}></textarea>
          </div>
        {/if}

      </div>
    </form>

  {:catch error}
    <p>Erreur: {error.message}</p>
  {/await}

  {#snippet footerButtons()}
    <button type="submit" class="button submit" form="clinic-opening-form">Enregistrer</button>
  {/snippet}
</Modal>
